var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1310 3949 c-131 -67 -139 -96 -146 -547 -6 -371 -3 -406 26 -395 19 7 46 13 62 13 25 0 29 61 27 385 l-2 384 53 46 52 45 1528 0 c1120 0 1542 -6 1579 -23 89 -41 94 -100 87 -1134 l-6 -967 -47 -38 c-45 -36 -93 -38 -1042 -38 l-994 0 -47 -50 c-26 -28 -39 -50 -28 -51 10 0 481 0 1046 1 1121 1 1096 -1 1176 118 l46 68 0 1002 c0 1121 2 1106 -140 1177 -100 50 -3132 53 -3230 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120 2888 c-154 -67 -248 -214 -248 -388 0 -453 619 -583 810 -170 158 342 -212 710 -562 558z m356 -121 c191 -139 172 -441 -34 -546 -325 -166 -634 244 -378 500 110 109 296 130 412 46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2639 2651 c-63 -35 -559 -543 -728 -746 l-54 -64 -73 32 c-513 221 -1250 47 -1344 -318 -12 -47 -44 -164 -72 -261 -52 -185 -50 -214 13 -214 39 0 37 -6 137 357 53 193 81 232 218 301 336 169 742 176 1052 18 l79 -41 152 158 c83 87 259 273 391 415 290 310 390 355 446 196 29 -85 22 -94 -516 -667 -738 -787 -693 -733 -652 -773 31 -32 42 -25 169 106 432 447 1073 1149 1100 1206 84 176 -148 392 -318 295z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload5);
export default __webpack_public_path__ + "static/media/picsvg_download(5).b8e4cf20f0c2e9044206a500f30e9ecd.svg";
export { ForwardRef as ReactComponent };